export const venues: TableModule = {
    name: "venues",
    route: "spa.basicData.venues",
    defaultOrder: {
        column: "city",
        direction: "asc"
    },
    columns: [
        {
            name: "name",
            sortable: true,
            pageLink: true,
            mobile: true
        }, {
            name: "address",
            sortable: true,
            sortBy: "city",
            mobile: true,
        }
    ],
    filters: [],
    quickFilters: [],
    tools: [
        {
            isCreateAction: true,
            ability: ["create", "venues"]
        }
    ]
}